// AdsService.js
import requests from "./api/api";

const AdsService = {
    getAllAds: (params) => requests.get('/car-rent-sale/v1/get-all-ads', params),
    getAdById: (id) => requests.get(`/car-rent-sale/v1/get-by-id/${id}`),
    likeAd: (body) => requests.post(`/user/v1/save-rental-sale-for-user`, body),
    disLikeAd: (body) => requests.post(`/user/v1/remove-rental-sale-from-save-user`, body),
    myAds: () => requests.get('/car-rent-sale/v1/get-by-userId'),
    // API expects JSON body like { RentalSaless: "<id>" } on this endpoint
    deleteMyAd: (body) => requests.delete('/car-rent-sale/v1/delete-user-sales', body),
    // Update an existing ad (PATCH) - payload should include the ad id and updated fields
    updateAd: (body) => requests.patch('/car-rent-sale/v1/update-by-user', body),

    likedAds: (body) => requests.get('/user/v1/saved-rental-sales', body),
    


    // ثبت آگهی با JSON
    registerAd: (data) => requests.post(`/car-rent-sale/v1/create-sales`, data),
};

export default AdsService;
